import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Fingerprint, Sparkles } from "lucide-react";

export const Route = createFileRoute("/security/keys")({
  component: KeysPage,
});

function KeysPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Fingerprint className="h-5 w-5" /> Clés cryptographiques
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">KMS · Rotation · Signature</p>
      </div>

      <div className="rounded-lg border border-indigo-500/30 bg-indigo-500/5 p-3 flex items-start gap-2 text-sm">
        <Sparkles className="h-4 w-4 text-indigo-400 mt-0.5" />
        <div><strong>Disponible en v7.0</strong> · KMS externe + rotation automatique.</div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Clés actives</CardTitle>
          <CardDescription>Les clés sont gérées au niveau du tenant</CardDescription>
        </CardHeader>
        <CardContent className="space-y-1.5 text-sm">
          <KeyRow name="JWT signing key" algo="HS256" status="active" />
          <KeyRow name="Audit hash chain seed" algo="SHA-256" status="active" />
          <KeyRow name="Password hashing salt" algo="Argon2id" status="active" />
          <KeyRow name="Refresh token HMAC" algo="HMAC-SHA256" status="active" />
          <KeyRow name="Document signing key" algo="RSA-2048" status="v7" />
          <KeyRow name="MFA TOTP secret" algo="TOTP-SHA1" status="active" />
        </CardContent>
      </Card>
    </div>
  );
}

function KeyRow({ name, algo, status }: { name: string; algo: string; status: string }) {
  return (
    <div className="flex items-center justify-between border-b border-white/5 pb-1.5">
      <span>{name}</span>
      <div className="flex items-center gap-2">
        <span className="font-mono text-xs text-muted-foreground">{algo}</span>
        <Badge variant={status === "active" ? "secondary" : "outline"} className="text-[10px]">{status}</Badge>
      </div>
    </div>
  );
}
